import gql from 'graphql-tag';

export const CCA_GENERATE_TEMPLATE_INPUTS_MUTATION = gql`
  mutation CcaGenerateTemplateInputsMutation(
    $articleIds: [ID!]!
    $perArticleOverrides: [TriggerCcaPerArticleOverrideInput!]
  ) {
    ccaGenerateTemplateInputs(articleIds: $articleIds, perArticleOverrides: $perArticleOverrides) {
      articles {
        articleId
        templates {
          templateId
          templateName
          inputs {
            name
            value
            missing
          }
        }
      }
      failures {
        articleId
        templateId
        templateName
        reason
      }
      errors
    }
  }
`;
